import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t bg-card mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_beatblend-63/artifacts/255zmwv6_White%20logo%20-%20no%20background.svg" 
              alt="Blendonics" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-muted-foreground">
              A Smarter Way to learn how to DJ.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Platform</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/pricing" className="hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link to="/#features" className="hover:text-primary transition-colors">Features</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">DJ Community</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/community" className="hover:text-primary transition-colors">Discussion</Link></li>
              <li><Link to="/reviews" className="hover:text-primary transition-colors">Reviews</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/terms/membership" className="hover:text-primary transition-colors">Membership Terms & Conditions</Link></li>
              <li><Link to="/terms/course" className="hover:text-primary transition-colors">Course Purchase Terms</Link></li>
              <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t mt-8 pt-8 text-center text-sm text-muted-foreground">
          <img 
            src="https://customer-assets.emergentagent.com/job_beatblend-63/artifacts/255zmwv6_White%20logo%20-%20no%20background.svg" 
            alt="Blendonics" 
            className="h-6 w-auto mx-auto mb-2"
          />
          <p>&copy; 2025 Blendonics. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
